import { useEffect, useRef, useState } from "react";

import { IconChevronLeft, IconChevronRight } from "@tabler/icons";
import { useLocation } from "react-router-dom";
import { useTheme } from "styled-components";

import { PathKeys } from "@sso/constant";
import { useMediaQuery } from "@sso/hooks/useMediaQuery";
import { Flex, Wrapper } from "@sso/ui/FlexBox";

import { ProfileTabContainer } from "./ProfileTabContainer";
import { ProfileTabItem } from "./ProfileTabItem";
import { ProfileTabNavigationButton } from "./ProfileTabNavigationButton";

const tabs = [
  { title: "Edit Profile", path: PathKeys.EDIT_PROFILE },
  { title: "Change Password", path: PathKeys.CHANGE_PASSWORD },
];

export const ProfileTab = () => {
  const theme = useTheme();
  const { pathname } = useLocation();
  const [isScrollable, setIsScrollable] = useState(false);
  const isUpSM = useMediaQuery(`(min-width: ${theme.breakpoints.sm})`);

  const tabContainerRef = useRef<HTMLDivElement>(null!);

  const index = tabs.findIndex(tab => tab.path === pathname);

  const showNavigationButtons = isUpSM && isScrollable;

  const handleScrollLeft = () => (tabContainerRef.current.scrollLeft = 0);
  const handleScrollRight = () =>
    (tabContainerRef.current.scrollLeft += tabContainerRef.current.scrollWidth / tabs.length);

  useEffect(() => {
    if (!tabContainerRef.current) {
      return;
    }
    function handleChange() {
      if (tabContainerRef.current.clientWidth < tabContainerRef.current.scrollWidth) {
        setIsScrollable(true);
      } else {
        setIsScrollable(false);
      }
    }
    handleChange();
    window.addEventListener("resize", handleChange);
    return () => window.removeEventListener("resize", handleChange);
  }, [isScrollable]);

  return (
    <Wrapper position="relative" width="100%" height="45px" padding={showNavigationButtons ? "0 30px" : "0"}>
      {showNavigationButtons && (
        <ProfileTabNavigationButton Icon={IconChevronLeft} left="0" onClick={handleScrollLeft} />
      )}
      <ProfileTabContainer ref={tabContainerRef}>
        <Flex position="relative" borderBottom={`1px solid ${theme.colors.divider}`} flexGrow={1}>
          {tabs.map(tab => (
            <ProfileTabItem key={tab.path} active={pathname === tab.path} to={tab.path} title={tab.title} />
          ))}
          <Wrapper
            position="absolute"
            transition="left 0.3s"
            width={`${100 / tabs.length}%`}
            height="3px"
            left={`calc(${100 / tabs.length}% * ${index})`}
            bgColor={theme.colors.primary.main}
            bottom="-1px"
          />
        </Flex>
      </ProfileTabContainer>
      {showNavigationButtons && (
        <ProfileTabNavigationButton Icon={IconChevronRight} right="0" onClick={handleScrollRight} />
      )}
    </Wrapper>
  );
};
